<template>

    <div class="text-center  mb-[0px] font-bold mt-[0px]  border-primary border border-t-[1px] border-b-[1px] pb-[20px] bg-offcream">

        <div class="topper mb-[20px] bg-primary" v-if="$store.getters.booking.reference">
          <h1 class="title text-white">** Editing Booking {{$store.getters.booking.reference}} **</h1>
        </div>

        <div v-if="$store.getters.booking.date" class="px-[20px] ">

            <label class=" text-xl !mb-[5px]  font-bold" style="padding-top: 0 !important;padding-bottom: 0 !important;"><span class="!text-black text-sm">You have requested:</span><br /><span class="text-primary text-xl">{{$store.getters.site.name}}</span></label>

            <!--hr class="o-hr mt-[10px]" /-->

            <div class="text-center inline-block md:block">

                <IconDate class="inline-block" /> <span class="text-primary font-bold">{{formattedDate}}</span>

                <!--br v-if="$store.getters.booking.time" class="block md:hidden" /-->

                <span class=" hidden md:inline-block px-[6px] font-bold">|</span>
                <span v-if="$store.getters.booking.time" class="ml-[10px] md:ml-[0px] inline-block"><IconTime class="inline-block"/> <span class="text-primary font-bold">{{$store.getters.booking.time}}</span></span>

                <span v-if="$store.getters.booking.time" class=" hidden md:inline-block px-[6px] font-bold ">|</span>
                <span  class="ml-[10px] md:ml-[0px] inline-block"><IconPeople class="inline-block"/> <span class="text-primary font-bold">{{$store.getters.booking.party_size}} People</span></span>

                <br class="block md:hidden" />

                <!--br class="block md:hidden" /-->
                <span v-if="$store.getters.booking.area" class=" hidden md:inline-block font-bold px-[6px]">|</span>
                <span v-if="$store.getters.booking.area"><IconHome class="inline-block"/> <span class="text-primary font-bold">{{($store.getters.booking.area)?$store.getters.booking.area.value.Name:''}}</span></span>
            </div>




        </div>
        <div v-else  class="flex justify-center relative mt-[10px] h-[56px]">
            <Spinner :small="true" :mb="false" />
        </div>
    </div>

</template>


<script>
import IconDate from "@/components/Icons/IconDate";
import IconTime from "@/components/Icons/IconTime";
import IconPeople from "@/components/Icons/IconPeople";
import IconHome from "@/components/Icons/IconHome";
import Spinner from "@/components/App/Spinner";
import moment from "moment";
export default {
  name: 'BookingInfo',
    props:['noTop','loadedBooking'],
  components:{
      Spinner,
      IconDate,
      IconTime,
      IconPeople,
      IconHome,
  },
  data(){
    return {

    }
  },
  mounted(){
      if(this.loadedBooking) this.setBookingInfo();
  },
  computed: {
      formattedDate(){
          if(!this.$store.getters.booking.date) return null;
          return moment(this.$store.getters.booking.date).format('DD/MM/YY')
      },
  },
  methods:{
    setBookingInfo(){
      this.$store.commit('setBooking',{key:'date',value:this.loadedBooking.date});
      this.$store.commit('setBooking',{key:'time',value:this.loadedBooking.time});
      this.$store.commit('setBooking',{key:'party_size',value:this.loadedBooking.party_size});
      this.$store.commit('setBooking',{key:'area',value:this.loadedBooking.area});
    }
  },

}
</script>
